export { ForgotPassword as default } from './ForgotPassword';
